/// <reference path="../../../typings/tsd.d.ts" /> 

module warsApp.controllers {
    export interface IFormGridModalScope extends angular.IScope {
        close: any;
        dismissModal: any;
        forms: Wars.Domain.Model.Form[];
        formSection:Wars.Domain.Model.FormSection;
        processConfigurationId:string;
        includedFormIds: string[];
        addColumn: any;
        onDragOver: any;
        onDropTreeItem: any;
        isSaveDisabled:any;
    }

    export class FormGridModalController extends BaseModalController {
        scope: IFormGridModalScope;

        constructor(
            scope: IFormGridModalScope,
            formSection: Wars.Domain.Model.FormSection,
            processConfigurationId:string,
            close: any,
            private formService: services.FormService,
            private treeService: services.TreeService,
            private schemaPropertyService:services.SchemaPropertyService) {
            super(scope, close);

            var self = this;

            this.scope = scope;
            this.scope.formSection=formSection;
            this.scope.processConfigurationId = processConfigurationId;
            this.scope.includedFormIds = [formSection.form_id];

            this.scope.addColumn = () => this.addColumn();
            this.scope.onDropTreeItem = (e, column) => this.onDropTreeItem(e, column);
            this.scope.isSaveDisabled=()=> this.isSaveDisabled();

        }

        public isSaveDisabled():boolean {
            return !Enumerable.from(this.scope.formSection.columns).all(c => c.schemaProperty != null);
        }

        public onDropTreeItem($event:any,column:Wars.Domain.Model.FormGridColumn) {
            var ti = this.treeService.getTreeConfigurationItem();
            this.schemaPropertyService.getSchemaProperty(ti.schemaPropertyId).then(prop => {
                column.schemaProperty = prop;
            });
        }

        public addColumn() {
            let column = this.formService.createFormGridColumn(this.scope.formSection);
            column.position = this.scope.formSection.columns.length;
            this.scope.formSection.columns.push(column);
            //this.formService.saveAllChanges();
        }
    }
}

warsApp.registerController('FormGridModalController', ['$scope', 'formSection', 'processConfigurationId', 'close', 'formService', 'treeService','schemaPropertyService']);